import type { Story } from '@/store/story-types'

export const ANALYTICS_DASHBOARD_NEW3_STORY: Story = {
  id: 'analytics-dashboard-new3',
  name: 'Analytics Pro — Dashboard',
  narrative: 'A comprehensive analytics dashboard with sidebar navigation, KPI cards, revenue line chart, traffic bar chart, user stats, data tables with pagination, and date-range report filters. Dark blue theme.',
  goals: ['View KPI overview cards', 'Analyze revenue and traffic charts', 'Browse user data tables with pagination', 'Filter reports by date range'],
  lifecycle: 'ready',
  pages: [
    { id: 'pg-overview', title: 'Overview', order: 0, status: 'completed', elementCount: 11, linkedPageId: 'overview', description: 'KPI cards, revenue chart, traffic chart, and quick stats' },
    { id: 'pg-users', title: 'Users', order: 1, status: 'completed', elementCount: 5, linkedPageId: 'users', description: 'User data table with search, filters, and pagination' },
    { id: 'pg-reports', title: 'Reports', order: 2, status: 'completed', elementCount: 5, linkedPageId: 'reports', description: 'Report builder with date range filters and export' },
  ],
  bddScenarios: [
    {
      id: 'bdd-1', name: 'View Dashboard Overview',
      description: 'User views the analytics overview',
      steps: [
        { type: 'given', text: 'the user opens the analytics dashboard' },
        { type: 'when', text: 'the overview page loads' },
        { type: 'then', text: 'KPI cards, revenue chart, and traffic chart are displayed', linkedPageId: 'overview' },
      ],
    },
    {
      id: 'bdd-2', name: 'Browse User Data',
      description: 'User browses the user data table',
      steps: [
        { type: 'given', text: 'the user navigates to the users tab' },
        { type: 'when', text: 'the users page loads' },
        { type: 'then', text: 'a data table with user records and pagination is shown', linkedPageId: 'users' },
      ],
    },
    {
      id: 'bdd-3', name: 'Filter Reports',
      description: 'User filters reports by date range',
      steps: [
        { type: 'given', text: 'the user navigates to the reports tab', linkedPageId: 'reports' },
        { type: 'when', text: 'they select a date range filter' },
        { type: 'then', text: 'report data updates to reflect the selected period' },
      ],
    },
    {
      id: 'bdd-4', name: 'Navigate via Sidebar',
      description: 'User navigates between dashboard sections',
      steps: [
        { type: 'given', text: 'the user is on any dashboard page' },
        { type: 'when', text: 'they click a sidebar navigation item' },
        { type: 'then', text: 'the corresponding section loads', linkedFlowId: 'navigate' },
      ],
    },
  ],
}
